import React, { useState } from "react";
import "./Confirmation.css";
import { useLocation } from "react-router-dom";
import Nav from "../Nav";
import Navbar from "../Navbar";
import Footer from "../Footer/Footer";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/database";
import { useNavigate } from "react-router-dom";

const mailchimp = require("@mailchimp/mailchimp_transactional")(
  "6a03c694803689100c4f590a67720407-us21"
);

const sendConfirmationEmail = async (email, name) => {
  const message = {
    to: [{ email, name }],
    from_email: "mainajm254@gmail.com",
    subject: "Thank you for registering for the conference!",
    text: "Dear {{name}},\n\nThank you for registering for the conference. We look forward to seeing you there!\n\nBest regards,\nThe conference team",
  };

  try {
    const response = await mailchimp.messages.send({ message });
    console.log("Email sent:", response);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDspQp0nJpp8kcZ4hPzwNTmcm-Pw1KF5EY",
  authDomain: "kippra-conference.firebaseapp.com",
  projectId: "kippra-conference",
  storageBucket: "kippra-conference.appspot.com",
  messagingSenderId: "833395988638",
  appId: "1:833395988638:web:350eb55f37c3ecd751838f",
};

firebase.initializeApp(firebaseConfig);

function Confirmation(props) {
  const location = useLocation();
  let { organization, type, position } = location.state;

  const [isSubmitted, setIsSubmitted] = useState(false); // state variable to keep track of submission status
  const [isError, setIsError] = useState(false); // state variable to keep track of error status

  // Get the conference participant's personal details from local storage
  const email = localStorage.getItem("email");
  const title = localStorage.getItem("title");
  const surname = localStorage.getItem("surname");
  const othernames = localStorage.getItem("othernames");
  const country = localStorage.getItem("country");
  const county = localStorage.getItem("county");
  const gender = localStorage.getItem("selectedgender");
  const phone = localStorage.getItem("phone");
  const disability = localStorage.getItem("disability");
  const role = localStorage.getItem("selectedrole");
  const countryCode = localStorage.getItem("countryCode");
  const consent = localStorage.getItem("consent");

  // Save the conference participant's details to Firebase when the Confirm button is clicked
  const handleConfirm = () => {
    const db = firebase.firestore();
    const databaseRef = firebase.database().ref("conferenceParticipants");

    // Query the collection for documents with a matching email address
    db.collection("conferenceParticipants")
      .where("email", "==", email)
      .get()
      .then((querySnapshot) => {
        if (!querySnapshot.empty) {
          // If a document exists, prevent the submission and show an error message
          setIsError(true);
          return;
        }
        // If the email address is unique, save the conference participant's details to Firestore and Realtime Database
        const data = {
          email,
          title,
          surname,
          othernames,
          country,
          county,
          gender,
          phone,
          disability,
          organization,
          type,
          position,
          role,
          countryCode,
          consent,
        };
        db.collection("conferenceParticipants")
          .add(data)
          .then(() => {
            // If the data was saved successfully, save the data to Realtime Database
            databaseRef.push(data);
            setIsSubmitted(true);

            // Send a confirmation email to the registered user
            sendConfirmationEmail(email, `${title} ${surname}`);
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      })
      .catch((error) => {
        console.error("Error querying documents: ", error);
      });
  };

  //...............................................................................................

  //navigate to respective forms when edit buttons are clicked
  const navigate = useNavigate();
  const handleProfesionEdit = () => {
    // Navigate back to the profession  form
    navigate("/professional");
  };

  const handlePersonalEdit = () => {
    // Navigate back to the profession  form
    navigate("/profile");
  };

  return (
    <div>
      <Nav />
      <Navbar />

      <div className="confirmation-container">
        <div className="personal-details">
          <h2>PERSONAL DETAILS</h2>
          <p>
            Email: <span className="inputs">{email}</span>{" "}
          </p>
          <p>
            Title: <span className="inputs">{title}</span>{" "}
          </p>
          <p>
            Surname: <span className="inputs">{surname}</span>
          </p>
          <p>
            othernames: <span className="inputs">{othernames}</span>
          </p>
          <p>
            Country <span className="inputs">{country}</span>
          </p>
          <p>
            County: <span className="inputs">{county}</span>
          </p>
          <p>
            Gender: <span className="inputs">{gender}</span>
          </p>
          <p>
            Phone No:{" "}
            <span className="inputs">
              {countryCode}
              {phone}
            </span>
          </p>
          <p>
            Disability: <span className="inputs">{disability}</span>
          </p>
          <p>
            Role in Conference: <span className="inputs">{role}</span>
          </p>

          {isSubmitted ? (
            // Display a message instead of the Edit button
            <p style={{ color: "#38169f" }}>
              Your personal details have been submitted successfully!
            </p>
          ) : (
            <button className="edit-button" onClick={handlePersonalEdit}>
              Edit
            </button>
          )}
        </div>

        <div className="professional-details">
          <h2>Professional Details:</h2>
          <p>
            Name of Organization: <span className="inputs">{organization}</span>
          </p>
          <p>
            Position: <span className="inputs">{position}</span>
          </p>
          <p>
            Type of Organization: <span className="inputs">{type}</span>
          </p>
          <p>
            Do you wish to receive email and phone Updates about Conference:
            <span className="inputs">{consent}</span>
          </p>
          {isSubmitted ? (
            // Display a message instead of the Edit button
            <p style={{ color: "#38169f" }}>
              Your professional details have been submitted successfully!
            </p>
          ) : (
            <button className="edit-button" onClick={handleProfesionEdit}>
              Edit
            </button>
          )}
        </div>

        <div className="confirm-button-container">
          {isSubmitted ? (
            <p className="success-message" style={{ color: "#04ed42" }}>
              Your details have been submitted successfully!
            </p>
          ) : (
            <button className="confirm-button" onClick={handleConfirm}>
              Submit
            </button>
          )}

          <div>
            {isError && (
              <p className="error-message" style={{ color: "red" }}>
                An account with this email already exists!
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="mt-4 text-grey-600">
        Already Registered?{" "}
        <span>
          <a
            onClick={() => navigate("/")}
            className="text-blue-700 hover:underline "
            href="/"
          >
            Home
          </a>
        </span>
      </div>

      <div style={{ marginTop: "30px" }}>
        <Footer />
      </div>
    </div>
  );
}

export default Confirmation;
